import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';
import logoSmall from '../../../../../assets/lucky_icon_title_small.svg';

const Logo = ({ className, ...props }) => {
    const classes = classNames('brand', className);

    return (
        <div {...props} className={classes}>
            <div className="m-0">
                <Link to="/" aria-label="Luckynote home">
                    {/* <div style={{ height: 40 }}> */}
                        <Image
                            src={logoSmall}
                            alt="Luckynote logo"
                            width={129}
                            height={24}
                        />
                    {/* </div> */}
                </Link>
            </div>
        </div>
    );
};

export default Logo;
